import { useAuthContext } from '@color/lib';
import constate from 'constate';
import { RefObject } from 'react';

import {
  useIsPatientOnboardedForMessaging,
  useSmoochInitQuery,
} from 'ui/PatientMessaging/apis/api';

interface Props {
  chatContainerRef: RefObject<HTMLDivElement>;
}

const usePatientMessaging = (props: Props) => {
  const { currentUser } = useAuthContext();
  const patientMessagingInitResponse = useSmoochInitQuery();
  const isPatientOnboardedForMessagingResponse = useIsPatientOnboardedForMessaging(
    currentUser?.patient_id
  );

  // data may be `null` (particularly seen on `Clinical V2`) and default values are not used when
  // the value the key is assigned to is `null` (only when not present or undefined). Therefore,
  // we need the additional destructuring and checking of `data`.
  const response = {
    patientMessagingInitResponse,
    isPatientOnboardedForMessagingResponse,
    ...props,
  };
  const { data } = isPatientOnboardedForMessagingResponse;
  if (!data) {
    return {
      isPatientOnboardedForMessaging: false,
      ...response,
    };
  }
  const { is_patient_messaging: isPatientOnboardedForMessaging = false } = data;
  return {
    isPatientOnboardedForMessaging,
    ...response,
  };
};

export const [PatientMessagingProviderWithoutRef, usePatientMessagingContext] =
  constate(usePatientMessaging);
